import commonMixin from '../../mixins/_common';

/**
 * pathの日本語名を表示するコンポーネント
 */
export default {
    name: 'path-names',
    template: '#path_names_template',
    props: {
        // カテゴリ全リスト
        categories: {
            type: Array,
            default: () => ([])
        },
        // 選択されたパスリスト
        path_config: {
            type: Array,
            default: () => ([])
        },
    },
    mixins: [
        commonMixin
    ],
    computed: {
        // パスを日本語に変換した表示用リスト
        pathNames: function () {
            if (!this.categories.length) {
                return [];
            }
            let pathNames = [];
            for (const path of this.path_config) {
                pathNames.push(this.getPathName(path));
            }
            // 選択した順で表示させるのでソートしない
            //            // ソート
            //            pathNames.sort(function(a,b){
            //                const aOrder = Number('0.' + a.order);
            //                const bOrder = Number('0.' + b.order);
            //                if (aOrder < bOrder) return -1;
            //                if (aOrder > bOrder) return 1;
            //                return 0;
            //            });
            return pathNames;
        },
    },
    methods: {
        // 指定パスから日本語名を取得
        getPathName: function (path) {
            let name = '';
            let order = '';
            let data = null;
            for (const i in this.categories) {
                const category = this.categories[i];
                if (category.page_key === path) {
                    data = _.cloneDeep(category);
                    break;
                }
            }
            if (data) {
                // 親page_keyがある場合は再帰的に遡る
                if (data.parent_page_key !== null) {
                    const parentData = this.getPathName(data.parent_page_key);
                    name = parentData.name;
                    order = parentData.order;
                }
                name += ' ＞ ' + data.name;
                order += this.adjustDigit(data.order);
            } else {
                name = ' ＞ 取得失敗'; 
                order = this.adjustDigit();
            }
            return {
                name: this.$_unEscape(name),
                order: order,
            };
        },
        // ゼロパディングで3桁にする
        adjustDigit: function (int = null, digit = 3) {
            return ('0'.repeat(digit) + int).slice(-(digit));
        },
    }
}; 